<template>
  <div class="col-md-12">
    <br />
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Type:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name="Type" v-model="encodingData.Type" class="form-control">
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.telephoneType"
              v-bind:key="option.telephoneType"
            >
              {{ option.telephoneType }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Phone Number :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            v-validate="'max:50'"
            name="PhoneNo"
            v-model="encodingData.PhoneNo"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('PhoneNo') }" />
                    <div v-if="submitted && errors.has('PhoneNo')"
                         class="invalid-feedback">
                        {{ errors.first("PhoneNo") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >IMSI :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Imsi"
            v-validate="'max:50'"
            v-model="encodingData.Imsi"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('Imsi') }" />
                    <div v-if="submitted && errors.has('Imsi')"
                         class="invalid-feedback">
                        {{ errors.first("Imsi") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="Country"
            v-model="encodingData.Country"
            class="form-control"
          >
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >State:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="SourceId"
            v-model="encodingData.State"
            class="form-control"
          >
            <option value>Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >City :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            v-validate="'max:50'"
            name="City"
            v-model="encodingData.City"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('City') }" />
                    <div v-if="submitted && errors.has('City')"
                         class="invalid-feedback">
                        {{ errors.first("City") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Address :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            v-validate="'max:50'"
            name="Address"
            v-model="encodingData.Address"
            class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('Address') }" />
                    <div v-if="submitted && errors.has('Address')"
                         class="invalid-feedback">
                        {{ errors.first("Address") }}
                    </div>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            rows="5"
            cols="5"
            class="form-control"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopTE" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  checkLinkMode,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageTelephoneType,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Type: "",
        PhoneNo: "",
        Imsi: "",
        Country: "",
        State: "",
        City: "",
        Address: "",
        Comments: "",
      },
      countries: [],
      provinces: [],
      types: [],
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      let loader = this.$loading.show();
      instance
        .post(EncodeURL + "newTelephone", this.encodingData, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error) {
            loader.hide();
            notifyHelper(
              "error",
              "There was an error processing your request!"
            );
          } else {
            loader.hide();
            notifyHelper("success", "Saved");
            //this.clearControls()
            if (checkLinkMode()) {
              if (confirm("Link this newly created entity?")) {
                setObject2Link(response.data.id, "TE");
                this.setLink(response.data.id);
              }
            }
          }
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstorageTelephoneType();
    },
    setLink: function (id) {
      setObject2Link(id, "TE");
      this.$bvModal.show("LinkPopTE");
    },
    clearControls() {
      
      this.encodingData.Type = "";
      this.encodingData.PhoneNo = "";
      this.encodingData.Imsi = "";
      this.encodingData.Country = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
      this.encodingData.Address = "";
      this.encodingData.Comments = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>
